<script>
import { HorizontalBar, mixins } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
const { reactiveProp } = mixins

export default {
    extends: HorizontalBar,
    components: {
        ChartJsPluginDataLabels,
    },
    mixins: [reactiveProp],
    props: {
        options: {
          type: Object,
          default: null
        }
    },
    mounted () {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.addPlugin(ChartJsPluginDataLabels);
        this.renderChart(this.chartData, this.options)
    }
}
</script>
